export enum Statuses {
	Draft,
	'In Progress',
	Approved,
	Returned,
	Done,
}

export enum SharePermissions {
	Read,
	Write,
	Manage,
}

export enum MessageSender {
	'user' = 'user',
	'chatGPT' = 'chatGPT',
	'System' = 'System',
	'hidden' = 'hidden',
}

export enum MessageActionTypes {
	'generate',
	'regenerate',
	'used',
	'error',
	'invalid',
}

export enum MessageActionStates {
	'default',
	'accept',
	'decline',
	'required',
}

export enum TicketStages {
	'general',
	'useCases',
	'testCases',
	'notifications',
	'report',
}

// order is important. It determines order of non functional requirements in UI

export enum GeneralStepConversationTopics {
	'Functional requirements',
	'Performance',
	'Scalability',
	'Portability and compatibility',
	'Reliability',
	'Maintainability',
	'Availability',
	'Security',
	'Usability',
}

export enum UseCaseTableFields {
	'Key Roles' = 'Key Roles',
	'Preconditions' = 'Preconditions',
	'Trigger' = 'Trigger',
	'Successful Outcome' = 'Successful Outcome',
	'Main Scenario Flow of Events' = 'Main Scenario Flow of Events',
}

// order is important. It determines order of diagram in UI on usecases step

export enum DiagramTypes {
	'Use Case Diagram' = 'Use Case Diagram',
	'Flowchart' = 'Flowchart',
	'Sequence Diagram' = 'Sequence Diagram',
}

export enum ChatGPTTemplateNames {
	'UsecaseConversationTemplate' = 'UsecaseConversationTemplate',
	'NotificationsConversationTemplate' = 'NotificationsConversationTemplate',
	'IsUserMessageValidTemplate' = 'IsUserMessageValidTemplate',
	'DescriptionTemplate' = 'DescriptionTemplate',
	'PotentialNotificationsTemplate' = 'PotentialNotificationsTemplate',
	'NotificationsTemplate' = 'NotificationsTemplate',
	'DiagramValidationTemplate' = 'DiagramValidationTemplate',
	'BannersTemplate' = 'BannersTemplate',
	'UserStoriesEpicsTemplate' = 'UserStoriesEpicsTemplate',
	'DiagramChangeRequestTemplate' = 'DiagramChangeRequestTemplate',
	'DiagramCorrectionTemplate' = 'DiagramCorrectionTemplate',
	'FlowOfEventsTableTemplate' = 'FlowOfEventsTableTemplate',
	'SuccessfulOutcomeTableTemplate' = 'SuccessfulOutcomeTableTemplate',
	'PreconditionsTableTemplate' = 'PreconditionsTableTemplate',
	'TriggerTableTemplate' = 'TriggerTableTemplate',
	'KeyRolesTableTemplate' = 'KeyRolesTableTemplate',
	'BusinessImpactTemplate' = 'BusinessImpactTemplate',
	'UseCaseDiagramTemplate' = 'UseCaseDiagramTemplate',
	'RegenerateUseCaseDiagramTemplate' = 'RegenerateUseCaseDiagramTemplate',
	'RegenerateSequenceDiagramTemplate' = 'RegenerateSequenceDiagramTemplate',
	'RegenerateFlowchartTemplate' = 'RegenerateFlowchartTemplate',
	'FlowchartTemplate' = 'FlowchartTemplate',
	'SequenceDiagramTemplate' = 'SequenceDiagramTemplate',
	'TestPlanTemplate' = 'TestPlanTemplate',
	'TestScenariosTemplate' = 'TestScenariosTemplate',
	'TestCasesTemplate' = 'TestCasesTemplate',
	'UserStoriesScenariosTemplate' = 'UserStoriesScenariosTemplate',
	'UserStoriesAcceptanceCriteriaTemplate' = 'UserStoriesAcceptanceCriteriaTemplate',
}

export enum ChatGPTStreamingTemplateNames {
	'PotentialSummaryTemplate' = 'PotentialSummaryTemplate',
	'SummaryTemplate' = 'SummaryTemplate',
}

export enum ChatGPTRagTemplateNames {
	'chatRAGTemplate' = 'chatRAGTemplate',
	'userStoriesRAGTemplate' = 'userStoriesRAGTemplate',
	'RAG' = 'RAG',
}

export enum ChatGPTSubStageTemplateNames {
	'FeaturesConversationTemplate' = 'FeaturesConversationTemplate',
	'PerformanceConversationTemplate' = 'PerformanceConversationTemplate',
	'ScalabilityConversationTemplate' = 'ScalabilityConversationTemplate',
	'PortabilityConversationTemplate' = 'PortabilityConversationTemplate',
	'ReliabilityConversationTemplate' = 'ReliabilityConversationTemplate',
	'MaintainabilityConversationTemplate' = 'MaintainabilityConversationTemplate',
	'AvailabilityConversationTemplate' = 'AvailabilityConversationTemplate',
	'SecurityConversationTemplate' = 'SecurityConversationTemplate',
	'UsabilityConversationTemplate' = 'UsabilityConversationTemplate',
}

export type mergedTemplateType =
	| ChatGPTTemplateNames
	| ChatGPTStreamingTemplateNames
	| ChatGPTSubStageTemplateNames;

export type aiRequestsModelsConfiguration = Partial<Record<mergedTemplateType, ChatGPTModels>>;

export enum ChatGPTModels {
	'GPT3.5-turbo',
	'GPT4',
	'GPT4-turbo',
	'GPT4-32K',
	'Mixtral',
	'Llama3',
	'GPT4o',
}

export enum PaymentStatus {
	'success' = 'success',
	'cancel' = 'cancel',
}

export enum HistoryActionTypes {
	'ticketCreate',
	'userStoriesGenerate',
	'userStoriesUpdate',
	'userStoriesEdit',
	'useCasesGenerate',
	'diagramsGenerate',
	'useCasesEdit',
	'notificationsGenerate',
	'notificationsUpdate',
	'notificationsEdit',
	'ticketApprove',
	'testCasesEdit',
}

export enum NamespacesList {
	'chatMessages' = 'chatMessages',
	'common' = 'common',
	'generalStep' = 'generalStep',
	'logInPage' = 'logInPage',
	'modals' = 'modals',
	'notificationsStep' = 'notificationsStep',
	'payment' = 'payment',
	'reportIssuePage' = 'reportIssuePage',
	'reportStep' = 'reportStep',
	'resetEmail' = 'resetEmail',
	'resetPassword' = 'resetPassword',
	'signUpPage' = 'signUpPage',
	'useCasesStep' = 'useCasesStep',
	'testCasesStep' = 'testCasesStep',
	'yupSchema' = 'yupSchema',
	'changesVersioning' = 'changesVersioning',
	'profilePage' = 'profilePage',
	'changePassword' = 'changePassword',
}

export enum LanguagesList {
	'en' = 'en',
	'ar' = 'ar',
}

export enum SubscriptionLevels {
	'Basic',
	'Starter',
}
